module.exports = __webpack_public_path__ + "img/terms-grid-2.2024b3aa.svg";